import React, {useEffect, useState} from 'react';
import {DateObject} from "react-multi-date-picker";
import ZofinoCalendar from "../../../system/components/zofino-calendar";
import TaskSidebar from "../../projects/components/task-sidebar";
import TaskDialog from "../../tasks/task-dialog";
import {CalendarEventContent} from "../../tasks/components/recurrence-calendar";
import {Message} from "primereact/message";
import {Button} from "primereact/button";
import {useTranslate} from "../../../system/useTranslate";

function Calendar({teamData, tasks = [], createTask, updateTask, tasksError, onChange}) {
    const translate = useTranslate();
    const [events, setEvents] = useState([]);
    const [selectedTask, setSelectedTask] = useState();
    const [taskDialogVisible, setTaskDialogVisible] = useState();
    const [selectedDate, setSelectedDate] = useState();

    useEffect(() => {
        setEvents(tasks.filter((task) => task.startAt || task.dueDate).map((task) => {
            const start = task.startAt || task.dueDate;
            const end = task.dueDate || task.startAt;
            return (
            {
                id:task.documentId || task.id,
                title:task.title,
                backgroundColor: task.taskStatus==="done"?"var(--surface-50)":"var(--green-500)",
                borderColor: task.taskStatus==="done"?"var(--surface-200)":"var(--green-500)",
                textColor: task.taskStatus==="done"?"black":"white",
                start:new DateObject(start).format("YYYY-MM-DD"),
                end:new DateObject(end).format("YYYY-MM-DD"),
                data:task
            });
        }))
    }, [tasks]);

    return(
        <div className="h-full flex flex-column gap-2">
            {tasksError && <div className="flex align-items-center gap-2 p-2">
                <Message severity="error" text={translate(tasksError)}/>
                <Button outlined size="small" icon="pi pi-refresh" label={translate("team.retry")} onClick={onChange}/>
            </div>}
            <ZofinoCalendar onAddEventClick={(e)=>{setSelectedDate(e);setTaskDialogVisible(true)}} eventTemplate={CalendarEventContent} events={events} setEvents={setEvents} onEventClick={(e)=>{setSelectedTask(e.event.extendedProps.data)}} onEventResize={(e)=>{updateTask(e.event.extendedProps.data, {startAt:e.event.start, dueDate:e.event.end})}} onEventDropped={(e)=>{updateTask(e.event.extendedProps.data, {startAt:e.event.start, dueDate:e.event.end})}}/>
            {tasks && <TaskSidebar selectedTask={tasks.find((task) => String(task.documentId || task.id) === String(selectedTask?.documentId || selectedTask?.id))} setSelectedTask={setSelectedTask} updateTask={updateTask}/>}
            <TaskDialog setVisible={setTaskDialogVisible} visible={taskDialogVisible} payload={{taskData:{
                startAt:selectedDate ? new Date(selectedDate).getTime()/1000 : undefined,
                dueDate:selectedDate ? new Date(selectedDate).getTime()/1000 : undefined,
                projects: teamData?.projects?.length === 1 ? [teamData.projects[0]] : [],
                workspace: teamData?.workspace?.documentId || teamData?.workspace?.id,
            }}} onSubmit={async (event)=>{await createTask(event); setTaskDialogVisible(false)}}/>
        </div>
    )
}

export default Calendar;
